/**
 * 🐦 Tweet Domain API Custom Axios Instance
 * shared/auth-core 통합 버전
 */

import { createOrvalCustomInstance } from '@edusense/shared-auth-core';

// Tweet API 베이스 URL 결정
const getTweetApiBaseUrl = (): string => {
  // 환경 변수 우선 사용
  const envUrl = process.env.REACT_APP_BACKEND_URL ||
                 process.env.VITE_API_BASE_URL ||
                 process.env.NEXT_PUBLIC_API_BASE_URL;

  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  // 기본값: API 게이트웨이
  return 'https://api.ugot.uk';
};

// Tweet 도메인용 커스텀 인스턴스 생성
export const customInstance = createOrvalCustomInstance(
  getTweetApiBaseUrl(),
  {
    timeout: 30000, // 30초 타임아웃
    enableDebug: true, // 🔍 디버깅: TokenManager lazy loading 검증
    onAuthError: () => {
      console.warn('API 인증 만료 - 토큰만 정리하고 현재 페이지 유지');
    },
  }
);

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;
